import { __assign } from "tslib";
import React from 'react';
import styles from './menu-trigger-container.module.css';
import classNames from 'classnames';
export var MenuTriggerContainer = React.forwardRef(function (props, ref) {
    return (React.createElement("div", __assign({}, props, { ref: ref, className: classNames(styles.menuTriggerContainer, props.className, "KPLR_MenuTriggerContainer") }), props.children));
});
MenuTriggerContainer.displayName = 'MenuButtonContainer';
export default MenuTriggerContainer;
